var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "url(#paint0_linear_3791_13134)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.8704 27.8289C52.4407 27.2914 53.1995 26.9942 53.9869 27.0001C54.7742 27.006 55.5284 27.3145 56.0904 27.8605C56.6524 28.4066 56.9781 29.1474 56.9989 29.9268C57.0197 30.7061 56.734 31.463 56.2019 32.0377L40.0498 52.0392C39.772 52.3354 39.4368 52.5731 39.0642 52.7381C38.6915 52.9031 38.2891 52.992 37.881 52.9995C37.4728 53.007 37.0674 52.9329 36.6888 52.7817C36.3103 52.6304 35.9664 52.4052 35.6778 52.1194L24.9663 41.5133C24.668 41.2381 24.4288 40.9062 24.2628 40.5375C24.0969 40.1687 24.0077 39.7706 24.0005 39.367C23.9933 38.9633 24.0683 38.5624 24.221 38.188C24.3737 37.8137 24.601 37.4737 24.8893 37.1882C25.1776 36.9027 25.521 36.6777 25.899 36.5265C26.2771 36.3753 26.682 36.301 27.0897 36.3082C27.4973 36.3153 27.8994 36.4036 28.2718 36.5679C28.6442 36.7323 28.9794 36.9692 29.2574 37.2645L37.7342 45.6539L51.7935 27.9171L51.8704 27.8289Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3791_13134",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5AB2AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5AB2AD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.6bce98932c4c89d0525da2b7e2209a8f.svg";
export { ForwardRef as ReactComponent };